import classNames from "../../classNames";
import React from "react";

const defaultProps = {
  navigateIcon: "bi bi-list",
};

function NavBar({
  className,
  onClickNavigate,
  navigateIcon,
  logo,
  title,
  action,
  isApproved,
  onClickSignOut,
}) {
  const classes = classNames(
    className,
    "navbar navbar-expand-lg navbar-light bg-primary",
  );

  return (
    <nav className={classes}>
      <div className="container-fluid">
        <button
          onClick={onClickNavigate}
          type="button"
          className="btn btn-sm btn-link fs-4 ps-0 text-black"
        >
          {!isApproved && <i className={navigateIcon}></i>}
        </button>
        <div className="d-flex align-items-center">
          <img src="/logo2.png" style={{ height: "40px", width: "40px" }}></img>
        </div>

        {(action && action()) ||
          (isApproved ? (
            <button
              onClick={onClickSignOut}
              type="button"
              className="btn btn-sm btn-link fs-4 ps-0 text-black"
            >
              <i className="bi bi-power"></i>
            </button>
          ) : (
            <div />
          ))}
      </div>
    </nav>
  );
}

NavBar.defaultProps = defaultProps;
export default NavBar;
